import FormHubScanTransferOrder from "components/Common/Form/FormHubScanTransferOrder";
import { useAttachImageToOrder, useUploadResource } from "hooks";
import { useCheckOrderAddToOrderTransfer } from "hooks/order-scan/useOrderScan";
import { useDeleteResource } from "hooks/resource-global/useResourceGlobal";
import ReactCamera from "pages/ ScanTheRow/ReactCamera/ReactCamera";
import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Alert,
} from "reactstrap";
import TransferOrderChild from "../TransferOrderChild";
import { useGetOrderNotes } from "hooks";
import WarningNoteItem from "pages/ ScanTheRow/WarningNoteItem";

const SearchOrderChildModal = ({
  isOpen,
  toggle,
  orderStatusList,
  t,
  mainForm,
  fieldChildName,
  fieldSearchOrderToAddName,
  onAddSearchOrder,
}) => {
  const orderChildRef = useRef(null);
  const inputSearch = useRef(null);
  const [messError, setMessError] = useState("");
  const [warningNoteModal, setWarningNoteModal] = useState(false);
  const [orderNotesData, setOrderNotesData] = useState(null);
  const [currentOrderId, setCurrentOrderId] = useState(null);
  const [currentOrderCode, setCurrentOrderCode] = useState(null);

  const { watch, setValue, setError } = mainForm;

  const {
    orderId,
    transferOrderType,
    hubSendOrderAdd,
    hubReceiveOrderAdd,
    myHubs,
  } = watch();

  const datatSearchOrderToAddName = watch(fieldSearchOrderToAddName) || [];
  const dataListChild = watch(fieldChildName) || [];

  const { refetch: refetchOrderNotes, isLoading: isLoadingOrderNotes } =
    useGetOrderNotes(
      { order_id: currentOrderId },
      data => {
        setOrderNotesData(data);
        setWarningNoteModal(true);
      },
      error => {
        console.error("Error fetching order notes:", error);
      }
    );

  const {
    mutate: mutateCheckOrderAddToOrderTransfer,
    isLoading: isLoadingCheckOrderAddToOrderTransfer,
  } = useCheckOrderAddToOrderTransfer({
    onSuccess: orderData => {
      // Check if order has is_noted flag
      if (orderData?.is_noted && orderData?.id) {
        setCurrentOrderId(orderData.id);
        setCurrentOrderCode(orderData.order_code);
        refetchOrderNotes();
      }

      const dataAdd = {
        id: orderData?.id,
        checker_date: orderData?.checker_date,
        order_code: orderData?.order_code,
        status: orderData?.status,
        type: orderData?.type,
        sender_name: orderData?.sender_name,
        sender_contact_phone: orderData?.sender_contact_phone,
        sender_full_address: orderData?.sender_full_address,
        reciever_name: orderData?.reciever_name,
        reciever_contact_phone: orderData?.reciever_contact_phone,
        reciever_full_address: orderData?.reciever_full_address,
        maker_date: orderData?.maker_date,
        ref_code: orderData?.ref_code,
        imagePath: orderData?.imagePath,
        transport_name: orderData?.transport_name,
      };
      if (dataListChild?.find(c => c?.order_code === orderData?.order_code)) {
        setMessError("Mã đơn này đã thêm vào");
      } else {
        addOrder(dataAdd);
      }
    },
    onError: ({ errorMessage, code }) => {
      setMessError(`${errorMessage} (Mã: ${code})`);
    },
  });

  const addOrder = dataAdd => {
    if (
      datatSearchOrderToAddName?.find(
        o => o?.order_code === dataAdd?.order_code
      )
    ) {
      setMessError("Mã đơn này đã thêm vào");
      return;
    }

    // Có thông tin order thì trigger chụp hình
    startCaptureImage(dataAdd.id);
    setValue(fieldSearchOrderToAddName, [
      ...datatSearchOrderToAddName,
      dataAdd,
    ]);
  };

  const handleKeyDown = event => {
    setError("");
    setMessError("");
    if (event.key.toLowerCase() === "enter") {
      mutateCheckOrderAddToOrderTransfer({
        from_hub: hubSendOrderAdd?.id,
        to_hub: hubReceiveOrderAdd?.id,
        orderCode: inputSearch.current.value,
        orderTransferId: orderId,
        orderType: transferOrderType?.value,
      });
      inputSearch.current.value = "";
      inputSearch.current.focus();
    }
  };

  // Start Take photo for Order
  const webcamRef = useRef(null);
  const [imageCapture, setImageCapture] = useState(null);
  const [idOrderCapture, setIdOrderCapture] = useState(0);

  const startCaptureImage = idOrder => {
    setIdOrderCapture(idOrder);
    webcamRef?.current?.captureImage();
  };

  const onUploadImageSuccess = response => {
    if (response?.data?.id) {
      setImageCapture(prev => ({
        ...prev,
        idResouce: response?.data?.id,
      }));
      mutateAttachImageToOrder({
        order_id: idOrderCapture,
        data: {
          files: [response?.data?.id],
        },
      });
    }
  };

  const { mutate: mutateUploadImage } = useUploadResource(onUploadImageSuccess);
  const { mutate: mutateAttachImageToOrder } = useAttachImageToOrder();
  const { mutate: deleteResource } = useDeleteResource(
    () => {
      setImageCapture(null);
    },
    () => {}
  );

  const handleActiveCamera = ({ isConnect, message }) => {
    console.log(">> Camera is active : ", {
      isConnect,
      message,
    });
  };

  const handleCaptureImage = srcImage => {
    const data = new FormData();
    const cleanedBase64String = srcImage.replace(
      /^data:image\/[a-z]+;base64,/,
      ""
    );
    const fileName = `scan_${new Date().getTime()}.png`;
    data.append("file", convertBase64ToFile(cleanedBase64String, fileName));
    setImageCapture({
      srcImage: srcImage,
      fileName,
      idResouce: null,
    });
    mutateUploadImage(data);
  };

  function convertBase64ToFile(base64String, fileName) {
    const decodedData = window.atob(base64String);
    const byteCharacters = decodedData;
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/octet-stream" });
    const file = new File([blob], fileName);
    return file;
  }
  // End Take photo for order

  const handleCloseWarningModal = () => {
    setWarningNoteModal(false);
    setOrderNotesData(null);
    setCurrentOrderId(null);
    setCurrentOrderCode(null);
  };

  return (
    <>
      <Modal
        size="xl"
        isOpen={isOpen}
        toggle={toggle}
        centered={true}
        style={{ overflow: "hidden" }}
      >
        <ModalHeader toggle={toggle} tag="h4">
          Thêm đơn con
        </ModalHeader>
        <ModalBody className="py-3 px-5">
          <Row>
            <Col xl={6} xs={12}>
              <div
                className="search-box mb-md-2 me-2 d-flex gap-2"
                style={{ flexWrap: "wrap" }}
              >
                <div style={{ width: "330px" }}>
                  <div className="position-relative">
                    <input
                      // value={searchTerm}
                      // disabled={isLoadingCheckOrderAddToOrderTransfer}
                      ref={inputSearch}
                      type="search"
                      onKeyDown={handleKeyDown}
                      className="form-control"
                      placeholder={`Nhập Mã đơn/Mã tham chiếu muốn tìm`}
                    />
                    <i
                      className="bx bxs-barcode search-icon"
                      style={{ color: "#50a5f1" }}
                    />
                  </div>
                  {messError && (
                    <div
                      className="mt-2 d-flex gap-1 align-items-center text-warning"
                      style={{ fontSize: "16px", fontStyle: "italic" }}
                    >
                      <i className="bx bx-error" />
                      <div>{messError}</div>
                    </div>
                  )}
                </div>

                <FormHubScanTransferOrder
                  isForSearchOrderToAdd
                  formHook={mainForm}
                  fieldNameHubSend={"hubSendOrderAdd"}
                  fieldNameHubReceive={"hubReceiveOrderAdd"}
                  disabled={true}
                  transferOrderType={transferOrderType?.value}
                />
              </div>
            </Col>
            <Col xl={6} xs={12}>
              <Card
                style={{
                  height: "100%",
                  width: "100%",
                }}
                className="camera-control"
              >
                <CardBody
                  style={{
                    height: "100%",
                  }}
                >
                  <div
                    className="d-flex mb-2"
                    style={{
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                    }}
                  >
                    <h5 style={{ width: "80px" }}>Hình ảnh</h5>
                    <div style={{ marginTop: "-7px" }}>
                      <ReactCamera
                        ref={webcamRef}
                        isAllowCapture={true}
                        // handleOnFocusListSelectCamera={() => {
                        //   setAllowFocusInputBarcode(false);
                        // }}
                        // handleOnBlurListSelectCamera={() => {
                        //   setAllowFocusInputBarcode(true);
                        // }}
                        handleActiveCamera={handleActiveCamera}
                        handleCaptureImage={handleCaptureImage}
                      ></ReactCamera>
                    </div>
                  </div>
                  {imageCapture && (
                    <div
                      style={{
                        position: "relative",
                      }}
                    >
                      <div className="image-container">
                        <img
                          src={imageCapture?.srcImage}
                          alt="Captured"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <i
                        className="fas fa-trash fa-lg text-danger trash-icon"
                        title="Xóa hình ảnh"
                        onClick={() => {
                          deleteResource(imageCapture?.idResouce);
                        }}
                        style={{
                          position: "absolute",
                          bottom: 0,
                          right: 0,
                          background: "#74788d",
                          padding: 10,
                          borderRadius: "8px 0 0 0",
                        }}
                      ></i>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            {" "}
            <TransferOrderChild
              ref={orderChildRef}
              pathDetail={"manage-orders"}
              title={"Danh sách đơn con thêm mới"}
              isShowBtnAddChild={false}
              isShowBtnDeleteChild={true}
              isDeleteTemp
              mainForm={mainForm}
              fieldChildName={fieldSearchOrderToAddName}
              orderStatusList={orderStatusList}
            />
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="danger"
            // disabled={isDisableButton}
            className="me-2 btn-label"
            onClick={() => toggle()}
          >
            <i className="bx bx-x label-icon" />
            Đóng
          </Button>
          <Button
            type="button"
            color="success"
            className="me-2 btn-label"
            disabled={datatSearchOrderToAddName?.length === 0}
            onClick={() => {
              onAddSearchOrder(datatSearchOrderToAddName);
              setValue(fieldSearchOrderToAddName, []);
              toggle();
            }}
          >
            <i className="bx bx-plus label-icon" />
            Thêm mới ({datatSearchOrderToAddName?.length} đơn con)
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={warningNoteModal}
        toggle={handleCloseWarningModal}
        centered
      >
        <div className="modal-content">
          <ModalBody style={{ padding: "16px" }}>
            <Alert
              color="warning"
              style={{ marginBottom: "12px", padding: "8px 12px" }}
            >
              Đơn hàng {currentOrderCode} được lưu ý !
            </Alert>
            {isLoadingOrderNotes ? (
              <div style={{ padding: "8px 0" }}>Đang tải dữ liệu lưu ý...</div>
            ) : (
              <WarningNoteItem
                reason={""}
                noted_description={""}
                notesData={orderNotesData}
              />
            )}
          </ModalBody>
          <ModalFooter style={{ padding: "12px 16px" }}>
            <Button onClick={handleCloseWarningModal}>Đóng</Button>
          </ModalFooter>
        </div>
      </Modal>
    </>
  );
};

SearchOrderChildModal.propTypes = {
  onAddSearchOrdere: PropTypes.any.isRequired,
  toggle: PropTypes.func,
  onDeleteClick: PropTypes.func,
  isOpen: PropTypes.any,
};

export default SearchOrderChildModal;
